import React, { memo } from "react";

import { DriverSourceEnum } from "services/api/fleet/vehicles/drivers/types";
import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";
import CheckIcon from "ui/modules/fleet/vehicles/pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleEditCard/components/VehicleWizardIntro/scenes/CheckIcon";

import { DRIVER_DOCUMENT_STEPS } from "../../../consts";
import { DRIVER_INTRO_SAMPLE } from "../consts";
import { DriverPersonSceneProps } from "../types";

/** Korak "Vozač": kartica vozača, popis isprava sa statusom i praćenje rokova. */
const DriverPersonScene: React.FC<DriverPersonSceneProps> = ({ formValues, source }) => {
  const isUser = source === DriverSourceEnum.USER;
  const isSelected = !!(formValues.userId || formValues.contactId);

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="flex flex-col items-center text-center pt-3">
            <span className="flex items-center justify-center w-20 h-20 rounded-full bg-blue-100 text-2xl font-bold text-blue-700">
              {DRIVER_INTRO_SAMPLE.initials}
            </span>
            <div className="mt-3 text-sm font-bold text-slate-800">{DRIVER_INTRO_SAMPLE.name}</div>
            <div className="text-[0.65rem] text-slate-400">Vozač vozila</div>
            <span
              className={
                isUser
                  ? "mt-3 px-2 py-0.5 rounded-full text-[0.65rem] font-semibold bg-blue-100 text-blue-700"
                  : "mt-3 px-2 py-0.5 rounded-full text-[0.65rem] font-semibold bg-violet-100 text-violet-700"
              }
            >
              {isUser ? "Korisnik aplikacije" : "Kontakt iz imenika"}
            </span>
          </div>
          <div className="mt-5 flex items-center justify-center gap-2 text-[0.65rem] text-slate-500">
            {isSelected ? <CheckIcon /> : <span className="w-5 h-5 rounded-full border-2 border-dashed border-slate-300" />}
            {isSelected ? "Vozač je odabran" : "Odaberite vozača"}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Isprave</div>
          <div className="mt-3 space-y-2">
            {DRIVER_DOCUMENT_STEPS.map((step) => {
              const hasDocument = !!formValues[step.numberField] || formValues[step.uploadsField].length > 0;

              return (
                <div key={step.uploadsField} className="flex items-center gap-2">
                  {hasDocument ? (
                    <CheckIcon />
                  ) : (
                    <span className="w-5 h-5 rounded-full border-2 border-dashed border-slate-300 flex-shrink-0" />
                  )}
                  <span className={hasDocument ? "text-[0.7rem] font-semibold text-slate-700" : "text-[0.7rem] text-slate-400"}>
                    {step.title}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Rokovi pod kontrolom"
          subtitle="Upozorenje prije isteka isprave"
          iconClassName="bg-blue-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#1D4ED8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 11a4 4 0 100-8 4 4 0 000 8z" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(DriverPersonScene);
